module.exports = __webpack_public_path__ + "assets/img/game-bg.74ba41b9.png";